module.exports = __webpack_public_path__ + "img/jiance.3b96de93.png";